import TweenMax from 'gsap/TweenMax';

export default function FrogJump(
  container,
  canvas,
  duration,
  beforeAnimation,
  onComplete
) {
  const {
    left: containerLeft,
    top: containerTop,
    height: containerHeight,
  } = container.getBoundingClientRect();
  const {
    left: canvasLeft,
    bottom: canvasBottom,
    width: canvasWidth,
  } = canvas.getBoundingClientRect();
  const initialX = -(containerLeft - canvasLeft) - canvasWidth / 2 - 50;
  const initialY = -(containerTop - canvasBottom + containerHeight);
  const frogImage = container.getElementsByTagName('img')[0];

  beforeAnimation(initialX, initialY);

  TweenMax.set(frogImage, {
    rotation: -45,
  });

  TweenMax.to(container, 0.5, {
    opacity: 1,
    onComplete: () => {
      TweenMax.to(container, duration, {
        rotation: 35,
        transformOrigin: `${canvasWidth * 1.5}px bottom`,
        onComplete,
      });
    },
  });
}
